module.exports = __webpack_public_path__ + "img/contents_global_network_map.09672be.png";